// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Banner-cls1__ae95f7e7513dba1705de{/*!*/}.Banner-cls2___4b78af3c4f04446e068{line-height:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Banner-cls1__ae95f7e7513dba1705de",
	"cls2": "Banner-cls2___4b78af3c4f04446e068 Banner-cls1__ae95f7e7513dba1705de"
};
export default ___CSS_LOADER_EXPORT___;
